import { Layout } from "antd";
import Content from "./Content/Content";
import Sidebar from "./Sidebar/Sidebar";
const LayoutAdmin = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <Content />
      </Layout>
    </Layout>
  );
};
export default LayoutAdmin;
